import { BracketMatchupCard } from "@landing/components/madness/BracketMatchupCard"
import type { Matchup } from "@landing/data/bracket-types"
import { nbaMatchups } from "@landing/data/nba-data"
import { memo } from "react"
import { demoSectionConfig } from "./data/demo-section-config"
import type { DemoFilter } from "./hooks/use-demo-cards-state"
import { LandingBracketCard } from "./LandingBracketCard"
import { LandingDemoCFBBracket } from "./LandingDemoCFBBracket"
import { nflOutcomes } from "./LandingDemoData"
import { LandingDemoMLBBracket } from "./LandingDemoMLBBracket"
import { LandingDemoNCAABBracket } from "./LandingDemoNCAABBracket"

interface DemoContentProps {
  activeFilter: DemoFilter
  cfbExpanded: boolean
  nflExpanded: boolean
  mlbExpanded: boolean
  ncaabExpanded: boolean
  isAnyCardExpanded: boolean
  handleToggleCfb: () => void
  handleToggleNfl: () => void
  handleToggleMlb: () => void
  handleToggleNcaab: () => void
}

export const DemoContent = memo(function DemoContent({
  activeFilter,
  cfbExpanded,
  nflExpanded,
  mlbExpanded,
  ncaabExpanded,
  isAnyCardExpanded,
  handleToggleCfb,
  handleToggleNfl,
  handleToggleMlb,
  handleToggleNcaab,
}: DemoContentProps) {
  const { nfl } = demoSectionConfig

  // Matchups view
  if (activeFilter === "matchups") {
    return (
      <>
        {nbaMatchups.map((matchup: Matchup) => (
          <BracketMatchupCard
            key={`${matchup.homeTeam.name}-${matchup.awayTeam.name}-${matchup.period}-${matchup.timeRemaining}`}
            {...matchup}
          />
        ))}
      </>
    )
  }

  // Bracket cards view
  if (activeFilter === "brackets") {
    const nflEnds = new Date(Date.now() + 1000 * 60 * 60 * 24 * nfl.daysFromNow)
    const nflStart = new Date()

    return (
      <>
        {/* NFL Demo */}
        <LandingBracketCard
          title={nfl.title}
          outcomes={nflOutcomes}
          imageUrl={nfl.imageUrl}
          volume={nfl.volume}
          progress={nfl.progress}
          ends={nflEnds}
          dateStart={nflStart}
          dateEnd={nflEnds}
          isExpanded={nflExpanded}
          onToggleExpand={handleToggleNfl}
          state={nfl.state}
          isAnyCardExpanded={isAnyCardExpanded}
          simulate
          preSelectedOutcomes={nfl.preSelectedOutcomes}
        />

        {/* CFB Demo */}
        <LandingDemoCFBBracket
          isExpanded={cfbExpanded}
          onToggleExpand={handleToggleCfb}
          isAnyCardExpanded={isAnyCardExpanded}
        />

        {/* MLB Demo */}
        <LandingDemoMLBBracket
          isExpanded={mlbExpanded}
          onToggleExpand={handleToggleMlb}
          isAnyCardExpanded={isAnyCardExpanded}
        />

        {/* NCAAB Demo */}
        <LandingDemoNCAABBracket
          isExpanded={ncaabExpanded}
          onToggleExpand={handleToggleNcaab}
          isAnyCardExpanded={isAnyCardExpanded}
        />
      </>
    )
  }

  return null
})
